import React from 'react';
import { Route } from 'react-router-dom';
import { List, Create, Update, Show, Pick } from '../components/song/';

export default [
    <Route path="/songs/pick" component={Pick} strict={true} key="pick" />,
    <Route path="/songs/create" component={Create} exact={true} key="create" />,
    <Route
        path="/songs/edit/:id"
        component={Update}
        exact={true}
        key="update"
    />,
    <Route path="/songs/show/:id" component={Show} exact={true} key="show" />,
    <Route path="/songs/:page?" component={List} strict={true} key="list" />
];



// WEBPACK FOOTER //
// ./src/routes/song.js